export const RESULTS_PER_PAGE = 24;
export const THIN_RESULTS_THRESHOLD = 5;
